export const MAX_NUMBER_OF_SUGGESTIONS = 5;
export const MAX_NUMBER_OF_WORK_SUGGESTIONS = 4;
